<template>
  <b-modal id="modal-mbwaytel" centered class="modal-mbwaytel">
    <div class="modal-mbwaytel-box">
      <div class="header">
        <button class="modal-mbwaytel-box-close" @click="$bvModal.hide('modal-mbwaytel')">
          <svg xmlns="http://www.w3.org/2000/svg" width="18.78" height="21.15" viewBox="0 0 18.78 21.15">
            <g id="Grupo_1753" data-name="Grupo 1753" transform="translate(-411.263 -553.556)">
              <g id="Grupo_1413" data-name="Grupo 1413" transform="translate(403.688 564.131) rotate(-45)">
                <path id="União_2" data-name="União 2" d="M18.15,0,9.075,7.779ZM0,0,9.075,7.779Z"
                  transform="translate(0 12.834) rotate(-45)" fill="none" stroke="var( --green-medium)"
                  stroke-linejoin="round" stroke-width="3" />
              </g>
              <g id="Grupo_1593" data-name="Grupo 1593" transform="translate(437.617 564.131) rotate(135)">
                <path id="União_2-2" data-name="União 2" d="M18.15,0,9.075,7.779ZM0,0,9.075,7.779Z"
                  transform="translate(0 12.834) rotate(-45)" fill="none" stroke="var( --green-medium)"
                  stroke-linejoin="round" stroke-width="3" />
              </g>
            </g>
          </svg>
        </button>
        <h2>Pagamento MBway</h2>
      </div>
    </div>
    <div class="modal-mbwaytel-form">
      <p>Indique o seu número de telefone</p>
      <input type="text" placeholder="Número telefone" v-model="phone" />
    </div>

    <div class="modal-mbwaytel-box-btns">
      <button class="btn-send" @click="savePhone()">Continuar</button>
    </div>
  </b-modal>
</template>

<script>
export default {
  data() {
    return {
      phone: '',
    };
  },
  methods: {
    savePhone() {
      localStorage.setItem('mbwaytelphone', this.phone);
      this.$bvModal.hide('modal-mbwaytel');
      this.phone = '';
    },
  },
};
</script>

<style lang="scss">
#modal-mbwaytel {

  .modal-header,
  .modal-footer {
    display: none;
  }

  .modal-dialog {
    max-width: 945px;
    margin: auto !important;

    @media screen and (max-width: 991px) {
      max-width: 384px;
    }
  }

  .modal-content {
    border-radius: 0;
    border: 0;
  }

  .modal-body {
    padding: 5.6rem 7.5rem 5rem 7.5rem;
    max-height: 945px;
    display: flex;
    flex-direction: column;

    @media (max-width: 991px) {
      padding: 50px 20px;
      height: 754px;
    }
  }
}

.modal-mbwaytel {
  &-box {
    display: flex;
    flex-direction: row-reverse;
    align-items: center;
    justify-content: space-between;

    >.header {
      display: flex;
      flex-direction: row-reverse;
      align-items: center;
      justify-content: space-between;
      width: 100%;
    }

    h2 {
      font-size: 3rem;
      font-weight: 700;
      color: #112d23;

      @media (max-width: 991px) {
        font-size: 1.8rem;
      }
    }

    &-close {
      width: 62px;
      height: 53px;
      display: flex;
      align-items: center;
      justify-content: center;
      background: var(--white);
      border: 1px solid var(--green-medium);
      border-radius: 10px;
      transition: 500ms;

      @media (max-width: 991px) {
        top: 20px;
        right: 20px;
        width: 40px;
        height: 40px;

        svg {
          max-width: 15px;
        }
      }

      &:hover,
      &:focus {
        opacity: 0.6;
      }
    }

    &-btns {
      .btn-send {
        width: 122px;
        height: 45px;
        background: var(--green-medium);
        border: 1px solid var(--green-medium);
        border-radius: 10px;
        box-shadow: 5px 5px 10px rgba(0, 0, 0, 0.16);
        font-size: 18px;
        font-family: "Font Regular";
        color: var(--white);
        transition: 500ms;

        &:hover,
        &:focus {
          cursor: pointer;
          background: var(--white);
          color: var(--green-medium);
        }
      }
    }
  }

  &-form {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: space-between;
    width: 100%;

    p {
      font-size: 2.5rem;
      font-family: "Font Regular";
      margin-top: 3rem;
      color: #112d23;

      @media (max-width: 991px) {
        font-size: 1.8rem;
      }
    }

    input {
      width: 70%;
      height: 7rem;
      background: var(--white);
      border: 1px solid #bebebe;
      border-radius: 10px;
      font-size: 2.5rem;
      font-family: "Font Regular";
      padding: 0 2rem;
      outline: none;
      margin-top: 1rem;
      margin-bottom: 4rem;

      @media (max-width: 991px) {
        height: 40px;
        font-size: 1.8rem;
      }
    }
  }
}
</style>
